import { TextInput } from '@mantine/core';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { computeAggregation } from 'components/forms/revision/fill-out/fields/aggregator-utils';
import { RevisionFieldProps } from 'components/forms/revision/fill-out/types';
import { IFormInputSpecMeasurementColumnAggregator } from 'pages/revisions-module/template-editor/editors/form/types';
import { useEffect, useMemo } from 'react';

/**
 * Aggregates data in a selected measurement table column.
 */
export default function RevisionFieldMeasurementColumnAggregator({
  spec,
  name,
  deviceId = 0,
}: RevisionFieldProps<IFormInputSpecMeasurementColumnAggregator>) {
  const { form } = useFillOutRevisionDataProvider();

  const value = useMemo(() => {
    const rows = form.values.devices[deviceId]?.measurements[spec.sectionId] || [];
    const columnValues = rows.map((row) => row[spec.inputName]);

    return computeAggregation(columnValues, spec.aggFunc, spec.separator, spec.selectedValue);
  }, [form.values, deviceId, spec.sectionId, spec.inputName, spec.aggFunc, spec.separator, spec.selectedValue]);

  useEffect(() => {
    const { value: currentValue } = form.getInputProps(name);

    if (currentValue !== value) {
      form.setFieldValue(name, value);
    }
  }, [form, name, value]);

  return <TextInput size="lg" required={spec.required} readOnly label={spec.label} {...form.getInputProps(name)} />;
}
